import * as z from "zod";

import { PartnerInstallSchema, ProductCodeSchema } from "../shared/install";

export const getInstalls = {
  name: "getInstalls" as const,
  input: z.object({
    /**
     * Capped at 100 to prevent oversize responses from a misbehaving
     * client. Default 10 covers the recent-installs table on the
     * dashboard with one row of headroom.
     */
    limit: z.number().int().min(1).max(100).default(10).optional(),
    offset: z.number().int().min(0).default(0).optional(),
    productCode: ProductCodeSchema.optional(),
  }),
  output: z.object({
    installs: z.array(PartnerInstallSchema),
    total: z.number().int().min(0),
  }),
};
